var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHardHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HardHat",
    clipPath: "url(#clip0_1735_9857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M13.4395 20.0686V6.4823C11.1354 7.13545 9.10739 8.52269 7.66351 10.4333C6.21963 12.344 5.43875 14.6737 5.43945 17.0686V20.0686H13.4395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M19.4395 20.0686V6.4823C21.7435 7.13545 23.7715 8.52269 25.2154 10.4333C26.6593 12.344 27.4402 14.6737 27.4395 17.0686V20.0686H19.4395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.4395 20.0685H4.43945C3.88717 20.0685 3.43945 20.5163 3.43945 21.0685V24.0685C3.43945 24.6208 3.88717 25.0685 4.43945 25.0685H28.4395C28.9917 25.0685 29.4395 24.6208 29.4395 24.0685V21.0685C29.4395 20.5163 28.9917 20.0685 28.4395 20.0685Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.4395 20.0685V5.06854C13.4395 4.80333 13.5448 4.54897 13.7323 4.36144C13.9199 4.1739 14.1742 4.06854 14.4395 4.06854H18.4395C18.7047 4.06854 18.959 4.1739 19.1466 4.36144C19.3341 4.54897 19.4395 4.80333 19.4395 5.06854V20.0685",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.4395 20.0686V17.0686C27.4402 14.6737 26.6593 12.344 25.2154 10.4333C23.7715 8.52269 21.7435 7.13545 19.4395 6.4823",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.43945 20.0686V17.0686C5.43875 14.6737 6.21963 12.344 7.66351 10.4333C9.10739 8.52269 11.1354 7.13545 13.4395 6.4823",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1735_9857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.439453 0.0685425)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardHat);
export default __webpack_public_path__ + "static/media/hard-hat.b51f193448a77b1750cb276ab2c9b36f.svg";
export { ForwardRef as ReactComponent };